import { render } from "./InformacoesView.vue?vue&type=template&id=5ac9c7cd"
import script from "./InformacoesView.vue?vue&type=script&lang=js"
export * from "./InformacoesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__